<h1 class="type-headline"><ng-content></ng-content></h1>
